import React  from 'react';
import NextButton from '../../components/nextButton';
import sms20 from './images/sms20.png';
import './style.css';

const PageFraudsBegin = ({ onNextLevel, messNext, answer, setAnswer } ) => {
  return ( 
		<div className="section-info section-frauds-begin">
			<div className="content-rebus w-container">
				<div className="head-rebus">Я узнал, что наш ключ попал в добрые руки. Мне на телефон пришло 4 сообщения, помоги найти то, которое поможет мне попасть домой.</div>
				<NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext="вперёд" />
				</div>
				<img src={sms20} loading="lazy" alt="финик" className="image-10"/>
		</div>
  );
}

export default PageFraudsBegin;
